module.exports = __webpack_public_path__ + "static/img/logo1.edb5c7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo1.png
// module id = TrFT
// module chunks = 1